import axios from 'axios';

const baseURL = process.env.REACT_APP_V4_API_BASE_URL;

const headers = {
  Accept: 'application/json, text/javascript',
};

export const cultivoInteligenteClient = axios.create({ baseURL, headers });
